import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription, combineLatest, filter } from 'rxjs';

import { AuthService, OrganisationService } from '@core/services';

import { Action, Model } from '@shared/models';

@Directive({
    selector: '[appRestrictedAccess]',
    standalone: false,
})
export class RestrictedAccessDirective implements OnDestroy, OnInit {
    @Input() model?: Model;
    @Input() actions?: Action[];
    private orgUserSubscription?: Subscription;

    constructor(private element: ElementRef, private authService: AuthService, private orgService: OrganisationService) {}

    ngOnInit() {
        if (this.model === undefined || this.actions === undefined) {
            return;
        }
        this.orgUserSubscription = combineLatest([
            this.orgService.activeOrganisation,
            this.authService.activeUser,
            this.authService.adminMode,
        ])
            .pipe(filter((values) => values.map((val) => val !== undefined).every(Boolean)))
            .subscribe((_) => this.setAccess());
    }

    ngOnDestroy() {
        this.orgUserSubscription?.unsubscribe();
    }

    private setAccess() {
        if (
            this.model !== undefined &&
            this.actions !== undefined &&
            !this.actions.map((action) => this.orgService.userHasPermission(this.model!, action)).some(Boolean)
        ) {
            this.element.nativeElement.setAttribute('style', 'display:none !important');
        } else {
            this.element.nativeElement.style.display = null;
        }
    }
}
